export type Type =
  | 'tour'
  | 'viz'
  | 'floor planner'
  | 'project'
  | 'design shop'
  | 'getting started with viz'
  | 'meet viz your new favorite design tool'
  | 'how viz and the project planner work together'
  | 'what can you create with viz'
  | 'creating room renderings'
  | 'creating floor plans'
  | 'creating mood boards'
  | 'demos and tutorials'
  | 'importing color palette into a mood board'
  | 'how to import images and products'
  | 'how layers work'
  | 'how to remove and restore a product background'
  | 'understanding the editing options in viz'
  | 'choosing the right template for your room rendering'
  | 'setting the scale of your floor plan'
  | 'how to make a shoppable product board'
  | 'how to build your mood board in spoak'
  | 'uploading images to your mood board in spoak'
  | 'replacing images in your mood board in spoak'
  | 'adding text to your mood board in spoak'
  | 'changing the background color of your mood board in spoak'
  | 'how to use gridlines in spoak'
  | 'how to download & share your mood board in spoak'
  | 'adding walls and assets to your floor plan in spoak'
  | 'using the ruler tool in spoak'
  | 'adjusting measurements in your floor plan in spoak'
  | 'how to download & share your floor plan in spoak'
  | 'understanding your viz screen in spoak'
  | 'understanding the asset gallery in spoak'
  | 'understanding the editing options in viz in spoak'
  | 'understanding grouping in spoak'
  | 'how to download & share your rendering in spoak'
  | 'how to create a new project in spoak'
  | 'adding things to your project in spoak'
  | 'creating sections and sub-sections in spoak'
  | 'how to present & share your project in spoak'
  | 'how to add a client to your project in spoak'
  | 'submitting your project to a client in spoak'
  | 'where to find client feedback in spoak'
  | 'everything you need to know about the spoak budgeting tool'
  | 'using spoaks project planner'
  | 'introduction to the new viz'
  | 'how to create a vizi in the new viz'
  | 'getting started with spoak | demo series'

type Format = 'watch' | 'embed'
export type FormatType = 'video' | 'playlist'

export interface IdWithFormatType {
  id: string
  formatType: FormatType
}

const typeToIdMap: Record<Type, IdWithFormatType> = {
  tour: { id: 'oZkr0CeGJIg', formatType: 'video' },
  viz: { id: 'RU9xlIHPBM8', formatType: 'video' },
  'floor planner': { id: 'OwBmZmYHS9Q', formatType: 'video' },
  project: { id: '50GFBTKlxOI', formatType: 'video' },
  'design shop': { id: 'E8gM6PVN1nI', formatType: 'video' },
  'getting started with viz': {
    id: 'PL4Pdmm7rE1rV2-iS_EQKgvFtPFghWDSZU',
    formatType: 'playlist',
  },
  'meet viz your new favorite design tool': {
    id: 'RU9xlIHPBM8',
    formatType: 'video',
  },
  'how viz and the project planner work together': {
    id: '_JrLsXN2IZY',
    formatType: 'video',
  },
  'what can you create with viz': {
    id: 'MPsp0FDyZTg',
    formatType: 'video',
  },
  'creating room renderings': {
    id: 'PL4Pdmm7rE1rWzKSoZVQSgKN5WQ9SbLRD1',
    formatType: 'playlist',
  },
  'creating floor plans': {
    id: 'PL4Pdmm7rE1rWxfq-KeIcZ8opf_DwEV3n2',
    formatType: 'playlist',
  },
  'creating mood boards': {
    id: 'PL4Pdmm7rE1rXTTWXTQYJlLNLfZ62F8R18',
    formatType: 'playlist',
  },
  'demos and tutorials': {
    id: 'PL4Pdmm7rE1rUKCBHs8uHKS7Cz7OBMKhUd',
    formatType: 'playlist',
  },
  'importing color palette into a mood board': {
    id: 'bPiW5eIQfuA',
    formatType: 'video',
  },
  'how to import images and products': {
    id: 'Jfbd6PZNu2w',
    formatType: 'video',
  },
  'how layers work': {
    id: 'HDi6sGUC3UA',
    formatType: 'video',
  },
  'how to remove and restore a product background': {
    id: 'mQ1ujxs1Mp4',
    formatType: 'video',
  },
  'understanding the editing options in viz': {
    id: '2Is3mspfLCo',
    formatType: 'video',
  },
  'choosing the right template for your room rendering': {
    id: 'a3k80TvaXPM',
    formatType: 'video',
  },
  'setting the scale of your floor plan': {
    id: 'JijCIyjIlqQ',
    formatType: 'video',
  },
  'how to make a shoppable product board': {
    id: 'wS5afmN0KSE',
    formatType: 'video',
  },
  'how to build your mood board in spoak': {
    id: 'nu5QVZehtjI',
    formatType: 'video',
  },
  'uploading images to your mood board in spoak': {
    id: 'aaeadof-hl0',
    formatType: 'video',
  },
  'replacing images in your mood board in spoak': {
    id: 'rpcbrlN5SVw',
    formatType: 'video',
  },
  'adding text to your mood board in spoak': {
    id: 'xr76pMNymfc',
    formatType: 'video',
  },
  'changing the background color of your mood board in spoak': {
    id: 'RLUlHwGrRuA',
    formatType: 'video',
  },
  'how to use gridlines in spoak': {
    id: '3b3nrli4s2U',
    formatType: 'video',
  },
  'how to download & share your mood board in spoak': {
    id: 'LoriRHazLaI',
    formatType: 'video',
  },
  'adding walls and assets to your floor plan in spoak': {
    id: 'Mws0ecVqn9I',
    formatType: 'video',
  },
  'using the ruler tool in spoak': {
    id: '3ELQcvUF23Y',
    formatType: 'video',
  },
  'adjusting measurements in your floor plan in spoak': {
    id: 'EznSj6GKSEk',
    formatType: 'video',
  },
  'how to download & share your floor plan in spoak': {
    id: '6kG1Ws9Den0',
    formatType: 'video',
  },
  'understanding your viz screen in spoak': {
    id: 'pTIE9dBZCfI',
    formatType: 'video',
  },
  'understanding the asset gallery in spoak': {
    id: 'LXn21eszpBM',
    formatType: 'video',
  },
  'understanding the editing options in viz in spoak': {
    id: '2Is3mspfLCo',
    formatType: 'video',
  },
  'understanding grouping in spoak': {
    id: 'zOgY_iClyiw',
    formatType: 'video',
  },
  'how to download & share your rendering in spoak': {
    id: 'WKiTBnr6cvc',
    formatType: 'video',
  },
  'how to create a new project in spoak': {
    id: 'W3o7Wz5I_1U',
    formatType: 'video',
  },
  'adding things to your project in spoak': {
    id: '3QxWRCn0bho',
    formatType: 'video',
  },
  'creating sections and sub-sections in spoak': {
    id: 'Hr76SD_Uzdg',
    formatType: 'video',
  },
  'how to present & share your project in spoak': {
    id: 'z0vVkSgDN7c',
    formatType: 'video',
  },
  'how to add a client to your project in spoak': {
    id: 'C-sVwxq4unk',
    formatType: 'video',
  },
  'submitting your project to a client in spoak': {
    id: 'irgz8c18QEs',
    formatType: 'video',
  },
  'where to find client feedback in spoak': {
    id: 'rRpQ6WULX8I',
    formatType: 'video',
  },
  'everything you need to know about the spoak budgeting tool': {
    id: 'tr9dxP2U9OI',
    formatType: 'video',
  },
  'using spoaks project planner': {
    id: 'PL4Pdmm7rE1rUaXcymxWcEqJ8tF89aQLLb',
    formatType: 'playlist',
  },
  'introduction to the new viz': {
    id: 'mkaXFuJ6chs',
    formatType: 'video',
  },
  'how to create a vizi in the new viz': {
    id: 'PrGW_4taHpw',
    formatType: 'video',
  },
  'getting started with spoak | demo series': {
    id: 'PL4Pdmm7rE1rWOsXc56PskAHHgBUhzPovF',
    formatType: 'playlist',
  },
}

export function getYoutubeIdAndFormatType(type: Type) {
  return typeToIdMap[type]
}

function getYoutubePath(id: string, format: Format, formatType: FormatType) {
  if (format === 'watch') {
    if (formatType === 'video') {
      return `watch?v=${id}&`
    } else if (formatType === 'playlist') {
      return `playlist?list=${id}&`
    }
  } else if (format === 'embed') {
    if (formatType === 'video') {
      return `embed/${id}?enablejsapi=1&`
    } else if (formatType === 'playlist') {
      return `embed/videoseries?list=${id}&enablejsapi=1&`
    }
  }
}

export function getYoutubeLink(
  type: Type,
  format: Format,
  seconds: number = 0,
) {
  const { id, formatType } = typeToIdMap[type]
  const path = getYoutubePath(id, format, formatType)
  const params = `t=${seconds}s`
  return `https://www.youtube.com/${path}${params}`
}
